// dependencies
import PropTypes from "prop-types";
import React from "react";

// components
import Button from "../../../../../../components/Button";
import { Divider } from "../../../../../../components/Divider";
import SelectInput from "../../../../../../components/Inputs/SelectInput";
import Typography from "../../../../../../components/Text";

// utils
import forceInt from "../../../../../../utils/ForceInt";

// config
import config from "../../config";
// styles
import css from "./DeferredTiming.module.scss";

const DeferredTiming = (props) => {
	const { className, deferredTimes, setDeferredtimes, saveNotificationsTimingConfiguration } = props;

	let frequencyValue = "not-set";

	if (deferredTimes.length === 1) {
		frequencyValue = "once";
	} else if (deferredTimes.length === 2) {
		frequencyValue = "twice";

		// if the user has selected the same time for both notifications, we need to change the second one
		// default second time to change to Morning, but if morning is selected in forst time, go to Mid-Day
		if (deferredTimes[0].hour === deferredTimes[1].hour) {
			deferredTimes[1].hour = deferredTimes[1].hour === 9 ? 12 : 9;
		}
	}

	return (
		<div className={`${css.deferredTiming} ${className}`}>
			<div className={css.label}>
				<Typography size="paragraph-2" weight="semi-bold" color="neutral-9">
					When do you want to receive daily notifications?
				</Typography>
			</div>
			<div className={css.inputsRow}>
				<div className={`${css.inputContainer}`}>
					<SelectInput
						value={frequencyValue}
						results={config.dailyNotificationsOptions}
						onChange={(value) => {
							const copy = deferredTimes.slice();

							if (copy.length === 0) {
								copy.push({ hour: 12 });
							}

							if (value === "twice") {
								copy.push({ hour: 9 });
							}

							const nextState = value === "once" ? copy.slice(0, 1) : copy.slice(0, 2);
							setDeferredtimes(nextState);
						}}
					/>
				</div>

				{deferredTimes.map((deferredTime, index) => {
					const { hour } = deferredTime;

					return (
						<div key={`time-${index}`} className={css.inputContainer}>
							<SelectInput
								value={hour.toString()}
								results={config.timeOptions.filter(
									(hour) => Number(hour.toJS().id) !== deferredTimes[index - 1]?.hour
								)}
								onChange={(value) => {
									const nextState = deferredTimes.slice();
									nextState[index].hour = forceInt(value);
									setDeferredtimes(nextState);
								}}
							/>
						</div>
					);
				})}
				<Button
					data-testid="saveDailyNotificationsTiming"
					onClick={saveNotificationsTimingConfiguration}
					className={css.saveButton}
					color="green"
					disabled={saveNotificationsTimingConfiguration === null}
				>
					Save
				</Button>
			</div>
			<Divider />
		</div>
	);
};

DeferredTiming.propTypes = {
	setDeferredtimes: PropTypes.func.isRequired,
	saveNotificationsTimingConfiguration: PropTypes.func,
	deferredTimes: PropTypes.array.isRequired,
	className: PropTypes.string.isRequired,
};

export default DeferredTiming;
